import {ShapeCommand} from '../../commands.template';

export class FlowlineAddLineTextCommand extends ShapeCommand {
  services: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const edge = graph.model.getCell(this.object.flowlineMxKey);
    const lineJson = edge.getJson();

    const lineTextCell = this.services.shapeSpawnerSvc.createLineText(this.object, lineJson);

    graph.addCell(lineTextCell, edge);

    const action = {
      addLineText: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        key: this.object.key,
        text: this.object.text,
        position: this.object.position
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const lineTextCell = graph.model.getCell(`${this.object.flowlineMxKey}-${this.object.key}`);

    graph.removeCells([lineTextCell], false);

    const action = {
      deleteLineText: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        key: this.object.key
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }
}
